import React, { CSSProperties, ReactNode } from 'react';
import { Typography } from 'antd';
import { legacyTextColor } from '@/utils/legacyColor';

const { Paragraph } = Typography;

interface CustomParagraphProps {
  text?: ReactNode;
  htmlString?: string;
  color?: string;
  strong?: boolean;
  fontSize?: string | number;
  lineHeight?: string | number;
  marginBottom?: string | number;
  marginTop?: string | number;
  fontWeight?: string | number;
  textAlign?: 'left' | 'center' | 'right' | 'justify';
  whiteSpace?: CSSProperties['whiteSpace'];
  ellipsis?: boolean;
  noText?: string;
  textTransform?:
    | 'none'
    | 'capitalize'
    | 'uppercase'
    | 'lowercase'
    | 'full-width'
    | 'full-size-kana';
  style?: CSSProperties;
  className?: string;
}

const CustomParagraph: React.FC<CustomParagraphProps> = ({
  text,
  htmlString,
  color,
  strong,
  fontSize,
  lineHeight,
  marginBottom,
  marginTop,
  fontWeight,
  textAlign,
  whiteSpace,
  ellipsis = false,
  noText = '',
  textTransform = 'none',
  style = {},
  className,
}) => {
  if (htmlString) {
    const divStyle = {
      color: legacyTextColor(color),
      fontSize: fontSize,
      lineHeight: lineHeight,
      fontWeight: fontWeight,
      marginBottom: marginBottom,
      marginTop: marginTop,
      textAlign: textAlign,
      whiteSpace: whiteSpace, // Keep this for potential newline/whitespace handling in the generated HTML
      ...style, // Allow overriding with explicit style prop
    };
    return (
      <div
        className={className}
        style={divStyle}
        dangerouslySetInnerHTML={{ __html: htmlString }}
      />
    );
  }

  // For plain text rendering, use all original props including ellipsis, level, strong
  return (
    <Paragraph
      className={className}
      ellipsis={ellipsis}
      strong={strong}
      style={{
        color: legacyTextColor(color),
        marginTop: marginTop,
        fontSize: fontSize,
        lineHeight: lineHeight,
        fontWeight: fontWeight,
        marginBottom: marginBottom,
        textTransform: textTransform,
        textAlign: textAlign,
        whiteSpace: 'pre-line',
        overflowWrap: 'break-word',
        ...style,
      }}
    >
      {text ? text : noText}
    </Paragraph>
  );
};

export default CustomParagraph;
